import { CircleCheck, Info, Lightbulb, X } from "lucide-react";
import React from "react"

interface SimpleAlertProps {
    message: string;
    variant?: 'success' | 'error' | 'warning' | 'info';
}

const SimpleAlert: React.FC<SimpleAlertProps> = ({
    message,
    variant='success'
}) => {

  const alertStyles = {
    success: 'bg-emerald-50 text-emerald-500 shadow-emerald-400/20 ring-emerald-600 border-emerald-100',
    error: 'bg-red-50 text-red-500 shadow-red-400/20 ring-red-600 border-red-100',
    warning: 'bg-yellow-50 text-yellow-500 shadow-yellow-400/20 ring-yellow-600 border-yellow-100',
    info: 'bg-blue-50 text-blue-500 shadow-blue-400/20 ring-blue-600 border-blue-100',
  };

  const icons = {
    success: <CircleCheck className="bg-emerald-50" />,
    error: <X className="bg-red-50" />,
    warning: <Lightbulb className="bg-yellow-50" />,
    info: <Info className="bg-blue-50" />,
  };
  return (
    <>
      <div
        className={`flex w-full items-center gap-4 border px-4 py-3 text-xs ${alertStyles[variant]}`}
        role="alert"
      >
        {icons[variant]}
        <p>{message}</p>
      </div>
    </>
  )
}

export default SimpleAlert;